<template>
	<IframeContainer v-if="pageViewerVisible" :source="pageViewerSource" />
</template>

<script>
import IframeContainer from '@/components/shells/iframe-container/iframe-container.vue';
import { mapGetters, mapActions } from 'vuex';
import messageHandlerMixin from '@/mixins/message-handler-mixin';

/**
 * Component used to iframe pages from AccessWeb
 * for integration purposes
 */
export default {
	name: 'AccessPageViewer',
	mixins: [messageHandlerMixin],
	components: {
		IframeContainer
	},
	computed: {
		...mapGetters('integration', ['pageViewerSource', 'pageViewerVisible'])
	},
	methods: {
		...mapActions('integration', [
			'setPageViewerVisibleAction',
			'setPageViewerSourceAction'
		]),
		onMessage(data) {
			//receive the close message from AccessWeb
			if (data && data === 'vue.closeNotificationModal') {
				this.setPageViewerVisibleAction(false);
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
